// https://github.com/WordPress/gutenberg/issues/12200#issuecomment-459560313
export default ()=>document.body.classList.contains( 'block-editor-page' );